import { BookOpen, Brain, Feather, Globe, Moon, PenLine, Sparkles, Sun } from "lucide-react";
import { accountsOrigin, accountsSignInUrl } from "../api/accounts";
import { accountsCopy } from "../api/accounts-copy";
import { storySignInCopy } from "../api/sign-in-copy";
import { storyLocales, useStoryPreferences, type StoryLocale } from "../i18n";
import "../auth.css";

export function SignInGate() {
  const { locale, setLocale, theme, toggleTheme, t } = useStoryPreferences();
  const copy = storySignInCopy[locale];
  const authCopy = accountsCopy[locale];
  const features = [[Brain, copy.memory], [BookOpen, copy.bible], [Sparkles, copy.intelligence], [PenLine, copy.workflow]] as const;
  const localeNames: Record<StoryLocale, string> = { "zh-Hans": "简体中文", "zh-Hant": "繁體中文", en: "English", ja: "日本語", ko: "한국어" };

  return <main className={`story-auth-page${theme === "dark" ? " is-dark" : ""}`}>
    <section className="story-auth-brand-panel" aria-label={copy.product}>
      <span className="story-auth-illustration" aria-hidden="true" />
      <div className="story-auth-brand"><Feather aria-hidden /><span><strong>Story</strong><small>{copy.product}</small></span></div>
      <div className="story-auth-brand-content">
        <div className="story-auth-promise"><h1>{copy.headline}</h1><p>{copy.tagline}</p></div>
        <div className="story-auth-features">{features.map(([Icon, item]) => <article key={item[0]}><span><Icon aria-hidden /></span><div><strong>{item[0]}</strong><p>{item[1]}</p></div></article>)}</div>
      </div>
    </section>
    <section className="story-auth-access">
      <div className="story-auth-controls">
        <label className="story-auth-locale-trigger"><Globe aria-hidden /><select value={locale} onChange={event => setLocale(event.target.value as StoryLocale)} aria-label={t("language")}>{storyLocales.map(value => <option key={value} value={value}>{localeNames[value]}</option>)}</select></label>
        <button type="button" onClick={toggleTheme} aria-label={copy.appearance} title={copy.appearance}>{theme === "dark" ? <Sun aria-hidden /> : <Moon aria-hidden />}</button>
      </div>
      <div className="story-auth-card" aria-labelledby="story-sign-in-title">
        <header><h2 id="story-sign-in-title">{copy.welcome}</h2><p>{copy.description}</p></header>
        <p className="story-auth-description">{authCopy.description}</p>
        <a className="story-auth-submit" href={accountsSignInUrl(locale)}>{authCopy.button}</a>
      </div>
      <footer className="story-auth-legal">{copy.terms} <a href={`${accountsOrigin}/terms?locale=${locale}`}>{copy.termsLink}</a> · <a href={`${accountsOrigin}/privacy?locale=${locale}`}>{copy.privacyLink}</a></footer>
    </section>
  </main>;
}
